"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCaptchaContainer = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const injectors_1 = require("og-core/store/injectors");
const slice_1 = require("./slice");
const saga_1 = require("./saga");
const ConfigProvider_1 = require("astra-core/containers/ConfigProvider");
function useCaptchaContainer() {
    // eslint-disable-next-line
    // @ts-expect-error
    (0, injectors_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
    (0, injectors_1.useInjectSaga)({ key: slice_1.sliceKey, saga: saga_1.captchaContainerSaga });
    const dispatch = (0, react_redux_1.useDispatch)();
    const newCaptchaEnabled = (0, ConfigProvider_1.useFeatureFlag)(ConfigProvider_1.EFeatureFlags.NEW_CAPTCHA_ENABLED);
    (0, react_1.useEffect)(() => {
        if (!newCaptchaEnabled) {
            return;
        }
        dispatch(slice_1.captchaContainerActions.fetchCaptchaProviders());
    }, [dispatch, newCaptchaEnabled]);
}
exports.useCaptchaContainer = useCaptchaContainer;
//# sourceMappingURL=index.js.map